import { Status } from 'services/api/api-client';
import { StatusItemType } from './stauts-item-type';
import { NodeType } from 'helpers/documents/types/base';
import { FolderStatus } from 'helpers/documents/types/documents';
import {
  getFolderStatusStyle,
  getStatusPillColor,
  useGetLocalizedStatus,
} from './documentStatusHelpers.ts';
import {
  PillButton,
  PillColor,
} from 'components/uikit/buttons/pill/PillButton.tsx';

type StatusItemProps = {
  itemType: NodeType;
  itemStatus: Status | FolderStatus;
  isFilter: boolean;
  onClick: () => void;
  statusAnchorRef?: any;
  className?: string;
  disabled?: boolean;
} & (
  | {
      buttonType: StatusItemType.ToggleButton;
      selected: boolean | undefined;
    }
  | {
      buttonType: StatusItemType.DefaultButton;
    }
);

export const StatusItem: React.FC<StatusItemProps> = (props) => {
  const getLocalizedStatus = useGetLocalizedStatus();

  if (props.itemType !== NodeType.Document) {
    return (
      <div
        data-test-id={'status'}
        className={getFolderStatusStyle(props.itemStatus as FolderStatus)}
      >
        {getLocalizedStatus(props.itemStatus)}
      </div>
    );
  }

  const selected =
    props.buttonType === StatusItemType.ToggleButton
      ? (props.selected ?? false)
      : props.isFilter
        ? false
        : undefined;

  return (
    <PillButton
      ref={props.statusAnchorRef}
      testId={'status'}
      title={getLocalizedStatus(props.itemStatus)}
      color={
        props.isFilter
          ? PillColor.Accent
          : getStatusPillColor(props.itemStatus as Status)
      }
      selected={selected}
      disabled={props.disabled}
      className={props.className}
      onClick={props.onClick}
    />
  );
};
